import React from 'react'

import { Box, Paper } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import theme from 'theme'

const EvidencesSkeleton = () => {
  return (
    <Paper
      component={Box}
      display="flex"
      flexDirection="column"
      gridGap={theme.spacing(2)}
      p={2}
    >
      <Skeleton variant="rect" width="20%" height={24} />

      {[0, 1].map((index) => (
        <Paper
          key={index}
          variant="outlined"
          component={Box}
          p={2}
          display="flex"
          flexDirection="column"
          gridGap={theme.spacing(2)}
        >
          <Skeleton variant="rect" width="50%" height={22} />
          <Skeleton variant="rect" width="80%" height={18} />
          <Skeleton variant="rect" width="100%" height={100} />
        </Paper>
      ))}
    </Paper>
  )
}

export default EvidencesSkeleton
